document.addEventListener('DOMContentLoaded', function () {
  let isProcessing = false;
  let lastCartState = null;
  let lastFetchTime = 0;
  const FETCH_COOLDOWN = 300;

  function updateCheckoutButton(cart) {
    const checkoutButton = document.querySelector('.checkout__button');
    const karafeMessage = document.querySelector('.cart-karafe-message');
    if (!checkoutButton || !karafeMessage) return;

    let karafeCount = 0;
    let totalCount = 0;

    if (cart && cart.items) {
      cart.items.forEach(item => {
        const vendor = (item.vendor || '').trim().toLowerCase();
        totalCount += item.quantity;

        if (vendor === 'karafe') {
          karafeCount += item.quantity;
        }
      });
    }

    const shouldDisable = karafeCount > 0 && karafeCount < 2 && totalCount === karafeCount;

    if (shouldDisable) {
      instantButtonBlock();
    } else {
      instantButtonUnblock();
    }

    lastCartState = { karafeCount, totalCount };
  }

  function fetchCartAndUpdate() {
    const now = Date.now();
    
    if (now - lastFetchTime < FETCH_COOLDOWN || isProcessing) {
      return;
    }
    
    isProcessing = true;
    lastFetchTime = now;
    
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        updateCheckoutButton(cart);
        isProcessing = false;
      })
      .catch(error => {
        console.error('Error fetching cart:', error);
        isProcessing = false;
      });
  }

  function instantButtonBlock() {
    const checkoutButton = document.querySelector('.checkout__button');
    const karafeMessage = document.querySelector('.cart-karafe-message');
    
    if (checkoutButton) {
      checkoutButton.disabled = true;
      checkoutButton.classList.add('btn--disabled');
      checkoutButton.title = "No se puede hacer checkout con menos de 2 productos de Karafe";
    }
    
    if (karafeMessage) {
      karafeMessage.style.display = 'block';
    }
  }

  function instantButtonUnblock() {
    const checkoutButton = document.querySelector('.checkout__button');
    const karafeMessage = document.querySelector('.cart-karafe-message');
    
    if (checkoutButton) {
      checkoutButton.disabled = false;
      checkoutButton.classList.remove('btn--disabled');
      checkoutButton.removeAttribute('title');
    }
    
    if (karafeMessage) {
      karafeMessage.style.display = 'none';
    }
  }

  // Interceptar clicks en el botón de checkout
  function handleCheckoutClick(e) {
    const checkoutButton = e.target;
    if (checkoutButton.disabled || checkoutButton.classList.contains('btn--disabled')) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }

    // Verificar una vez más antes de proceder
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        let karafeCount = 0;
        let totalCount = 0;

        if (cart && cart.items) {
          cart.items.forEach(item => {
            const vendor = (item.vendor || '').trim().toLowerCase();
            totalCount += item.quantity;
            if (vendor === 'karafe') {
              karafeCount += item.quantity;
            }
          });
        }

        if (karafeCount > 0 && karafeCount < 2 && totalCount === karafeCount) {
          e.preventDefault();
          e.stopPropagation();
          checkoutButton.disabled = true;
          checkoutButton.classList.add('btn--disabled');
          
          const karafeMessage = document.querySelector('.cart-karafe-message');
          if (karafeMessage) karafeMessage.style.display = 'block';
          
          return false;
        }
      });
  }

  fetchCartAndUpdate();

  // Event listener para el botón de checkout
  document.addEventListener('click', function(e) {
    if (e.target.matches('.checkout__button, .checkout__button *')) {
      const button = e.target.closest('.checkout__button');
      if (button) {
        handleCheckoutClick.call(button, e);
      }
    }
  });

  // DEBOUNCE ÚNICO - consolidado
  let debounceTimer;
  let pendingUpdate = false;

  function debouncedUpdate() {
    if (pendingUpdate) return;
    
    pendingUpdate = true;
    clearTimeout(debounceTimer);
    
    debounceTimer = setTimeout(() => {
      fetchCartAndUpdate();
      pendingUpdate = false;
    }, 250); // Un solo delay
  }

  // Observer para detectar cambios en el DOM del carrito
  const cartItemsContainer = document.querySelector('[data-line-items]');
  if (cartItemsContainer) {
    let observerCooldown = false;
    
    const observer = new MutationObserver((mutations) => {
      if (observerCooldown) return;
      
      let shouldUpdate = false;
      
      mutations.forEach(mutation => {
        if (mutation.type === 'childList' && 
            (mutation.addedNodes.length || mutation.removedNodes.length)) {
          const hasRelevantChanges = Array.from(mutation.addedNodes).some(node => 
            node.nodeType === Node.ELEMENT_NODE && 
            (node.matches('.cart-item, [data-line-item]') || 
             node.querySelector('.cart-item, [data-line-item]'))
          );
          if (hasRelevantChanges) shouldUpdate = true;
        }
      });

      if (shouldUpdate) {
        observerCooldown = true;
        setTimeout(() => observerCooldown = false, 300);
        debouncedUpdate();
      }
    });
    
    observer.observe(cartItemsContainer, { 
      childList: true, 
      subtree: true
    });
  }

  // UN SOLO evento para inputs (consolidado input + change)
  let inputCooldown = {};
  document.addEventListener('input', function(e) {
    if (!e.target.matches('input[name*="updates"], .cart-item__quantity input')) return;
    
    const inputId = e.target.name || e.target.id || 'default';
    const now = Date.now();
    
    const currentValue = parseInt(e.target.value) || 0;
    const cartItem = e.target.closest('.cart-item, [data-line-item]');
    
    // BLOQUEO INSTANTÁNEO si detectamos situación crítica
    if (cartItem) {
      const vendorElement = cartItem.querySelector('[data-vendor], .vendor');
      if (vendorElement) {
        const vendor = vendorElement.textContent.trim().toLowerCase();
        if (vendor === 'karafe' && currentValue === 1 && lastCartState?.totalCount === 2) {
          instantButtonBlock(); // ⚡ INMEDIATO - sin esperar
        }
      }
    }
    
    // Cooldown solo para el fetch, NO para el bloqueo
    if (inputCooldown[inputId] && now - inputCooldown[inputId] < 200) return;
    inputCooldown[inputId] = now;
    
    debouncedUpdate();
  });

  // Interceptar clicks en botones de cantidad +/-
  let clickCooldown = false;
  document.addEventListener('click', function(e) {
    if (!e.target.matches('.cart-item__quantity-button, .quantity-selector button, [data-quantity-change], .js-qty__adjust')) {
      return;
    }
    
    // Cooldown global para clicks
    if (clickCooldown) return;
    clickCooldown = true;
    setTimeout(() => clickCooldown = false, 300);
    
    const isDecreaseButton = e.target.textContent.includes('-') || 
                            e.target.classList.contains('decrease') ||
                            e.target.classList.contains('js-qty__adjust--minus') ||
                            e.target.getAttribute('data-quantity-change') === '-1';
    
    if (isDecreaseButton) {
      const cartItem = e.target.closest('.cart-item, [data-line-item]');
      if (cartItem) {
        const quantityInput = cartItem.querySelector('input[name*="updates"], .cart-item__quantity input');
        if (quantityInput) {
          const currentQty = parseInt(quantityInput.value) || 0;
          
          if (currentQty === 2 && lastCartState?.totalCount === 2) {
            const vendorElement = cartItem.querySelector('[data-vendor], .vendor');
            if (vendorElement) {
              const vendor = vendorElement.textContent.trim().toLowerCase();
              if (vendor === 'karafe') {
                instantButtonBlock();
              }
            }
          }
        }
      }
    }
    
    debouncedUpdate();
  }, true);

  // Al abrir el drawer
  const drawer = document.querySelector('[data-drawer="drawer-cart"]');
  if (drawer) {
    drawer.addEventListener('drawer:open', fetchCartAndUpdate);
  }

  // Eventos custom del carrito (consolidados con cooldown)
  let customEventCooldown = false;
  function handleCustomEvent() {
    if (customEventCooldown) return;
    customEventCooldown = true;
    setTimeout(() => customEventCooldown = false, 400);
    debouncedUpdate();
  }
  
  document.addEventListener('cart:updated', handleCustomEvent);
  document.addEventListener('cart:changed', handleCustomEvent);
  
  // Interceptor de fetch - SOLO para operaciones de escritura
  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    const url = args[0];
    
    // Solo interceptar URLs de carrito
    if (typeof url === 'string' && url.includes('/cart/')) {
      const promise = originalFetch.apply(this, args);
      
      // Solo actualizar en operaciones POST/PUT (no en GET)
      const method = args[1]?.method?.toUpperCase();
      if (method === 'POST' || method === 'PUT' || method === 'PATCH') {
        promise.then(() => {
          setTimeout(debouncedUpdate, 150);
        }).catch(() => {});
      }
      
      return promise;
    }
    
    return originalFetch.apply(this, args);
  };

});